var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.playInfo && _vm.playInfo.length > 0
    ? _c("section", { staticClass: "module dt-episode" }, [
        _c("h3", [
          _vm._v("\n    选集\n    "),
          _vm.item.finished === "1" || _vm.updatedEpisode === _vm.finishEpisode
            ? _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.finishEpisode !== "0",
                      expression: "finishEpisode !== '0'",
                    },
                  ],
                },
                [_vm._v("\n      共" + _vm._s(_vm.finishEpisode) + "集\n    ")]
              )
            : _vm.finishEpisode && _vm.finishEpisode !== "0"
            ? _c("span", [
                _vm._v(
                  "\n      更新至第" +
                    _vm._s(_vm.updatedEpisode) +
                    "集/共" +
                    _vm._s(_vm.finishEpisode) +
                    "集\n    "
                ),
              ])
            : _c("span", [
                _vm._v(" 更新至第" + _vm._s(_vm.updatedEpisode) + "集 "),
              ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "dt-episode-wrap" }, [
          _vm.updatedEpisode > 15
            ? _c("div", { staticClass: "dt-episode-choose" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selected,
                        expression: "selected",
                      },
                    ],
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.selected = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  _vm._l(_vm.playInfo, function (list, index) {
                    return _c(
                      "option",
                      {
                        key: index,
                        attrs: {
                          uigs:
                            "eposide_nav_" + _vm.playIndexInfo + "-" + index,
                        },
                        domProps: { value: index },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.optionVal(list)) +
                            "\n        "
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "dt-episode-list" },
            _vm._l(_vm.playInfo[_vm.selected], function (i, index) {
              return _c(
                "li",
                { key: index, class: { disabled: i.s === 0 } },
                [
                  i.s === 0
                    ? [
                        _c(
                          "span",
                          {
                            staticClass: "item-button",
                            attrs: { uigs: "play_" + i.index },
                          },
                          [_vm._v(_vm._s(i.index))]
                        ),
                      ]
                    : [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: i.url,
                              uigs: "play_" + i.index,
                              uigsparams: `play_type=lvideo&play_url=${encodeURIComponent(
                                i.url
                              )}&play_site=${_vm.site}`,
                            },
                          },
                          [_vm._v(_vm._s(i.index))]
                        ),
                        _vm._v(" "),
                        i.s === 3
                          ? _c("span", { staticClass: "tag-pre" }, [
                              _vm._v("预"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        i.s === 2
                          ? _c("span", { staticClass: "tag-vip" }, [
                              _vm._v("VIP"),
                            ])
                          : _vm._e(),
                      ],
                ],
                2
              )
            }),
            0
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }